<template>
<div class="page">
    <div class="m-b-24 bg-content padding15">
      <el-form size="small" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="24">
            <div class="text right">
              <el-button type="primary" size="small" plain @click="addNotice = true; cleanReq(); noticeVisible = true">添加</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="padding15">
        <el-table :data="noticeListRes" size="small" :row-style="{cursor: 'pointer'}" style="width: 100%" empty-text="暂无定时通知，请点击添加配置">
          <el-table-column prop="title" label="邮件标题"/>
          <el-table-column label="发送对象">
            <template slot-scope="scope">
              <span v-if="scope.row.mailTo == null">--</span>
              <span v-else-if="scope.row.mailTo.split(',').length <= 2">{{scope.row.mailTo}}</span>
              <span v-else>{{scope.row.mailTo.split(',')[0] + ',' + scope.row.mailTo.split(',')[1] + '....共' + scope.row.mailTo.split(',').length + '位'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发送时间">
            <template slot-scope="scope">
              <span v-if="scope.row.sendType == 1">每日 {{scope.row.sendTime}}</span>
              <span v-else-if="scope.row.sendType == 2">每周一 {{scope.row.sendTime}}</span>
              <span v-else-if="scope.row.sendType == 3">每月一号 {{scope.row.sendTime}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contentTypeStr" label="发送内容"/>
          <el-table-column prop="userName" label="添加人"/>
          <el-table-column prop="createTime" label="添加时间"/>
          <el-table-column
            prop="id"
            label="操作"
            width="313">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="updateStatus(scope.row.id, scope.row.status)"/>
              <el-button type="text" @click="editShow(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
              <el-button type="text" @click="deleteNotice(scope.row.id)"><i class="el-icon-delete"></i></el-button>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <div class="dialog">
      <el-dialog
        :title="addNotice ? '添加定时通知': '修改定时通知'"
        :visible.sync="noticeVisible"
        width="50%"
        center>
        <el-form label-width="140px">
          <el-form-item label="邮件标题：">
            <el-input v-model="noticeBodyReq.title" placeholder="请填入名称" maxlength="15"></el-input>
          </el-form-item>
          <el-form-item label="发送对象：">
            <el-input type="textarea" v-model="noticeBodyReq.mailTo" maxlength="800" placeholder="请填入邮箱，多个邮箱以逗号隔开" :autosize="{ minRows: 5}" resize="none"/>
          </el-form-item>
          <el-form-item label="发送内容：">
            <el-checkbox-group v-model="noticeBodyReq.contentType">
              <!--<div><el-checkbox label="1">批次分析报告(pdf)</el-checkbox></div>-->
              <div><el-checkbox label="2">批次报告-批次总览(邮件内文)</el-checkbox></div>
              <div><el-checkbox label="3">批次报告-案件明细(excel)</el-checkbox></div>
              <div><el-checkbox label="4">批次报告-交互记录(excel)</el-checkbox></div>
              <div><el-checkbox label="5">数据报告(excel)</el-checkbox></div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="发送时间：">
            <el-select v-model="noticeBodyReq.sendType" placeholder="请选择" @change="sendTypeChange">
              <el-option :value="1" label="每日"></el-option>
              <el-option :value="2" label="每周一"></el-option>
              <el-option :value="3" label="每月一号"></el-option>
            </el-select>
            <el-time-picker v-model="noticeBodyReq.sendTime" placeholder="选择发送时间" format="HH:mm" value-format="HH:mm:ss"/>
          </el-form-item>
          <el-form-item label="发送条件：">
            <el-checkbox-group v-model="noticeBodyReq.sendCondition">
              <div><el-checkbox label="1">{{sendTypeRelation}}作业完成</el-checkbox></div>
              <div><el-checkbox label="2">当前作业中</el-checkbox></div>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="生效：">
            <el-switch v-model="noticeBodyReq.status" active-text="开启" inactive-text="关闭"
                       :active-value="1" :inactive-value="0" :value="0"/>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="add" size="small" v-if="addNotice">保存</el-button>
          <el-button type="primary" @click="update" size="small" v-if="!addNotice">更新</el-button>
        </div>
      </el-dialog>
    </div>
</div>
</template>
<script>
export default {
  props: [
    'companyIdTemp'
  ],
  data() {
    return {
      noticeVisible: false,
      addNotice: null,
      noticeListReq: {
        // 搜索条件
        companyId: null
      },
      noticeListRes: [],
      noticeBodyReq: {
        title: null,
        mailTo: null,
        contentType: [],
        sendType: null,
        sendTime: null,
        sendCondition: [],
        status: null,
        companyId: null,
        id: null
      },
      sendTypeRelation: ''
    };
  },
  watch: {
    companyIdTemp(companyId) {
      this.noticeListReq.companyId = companyId;
      this.noticeBodyReq.companyId = companyId;
      this.noticeSearch();
    }
  },
  methods: {
    noticeSearch() {
      this.$ajax({
        method: 'POST',
        url: '/notice/list',
        data: this.noticeListReq
      }).then((res) => {
        this.noticeListRes = res.data;
      });
    },
    currentChange(page) {
      this.noticeListReq.page = page;
      this.noticeSearch();
    },
    // 显示条数
    sizeChange(num) {
      this.noticeListReq.limit = num;
      this.noticeSearch();
    },
    sort(column) {
      const prop = column.prop === null ? 'createTime' : column.prop;
      const order = column.order === null ? 'descending' : column.order;
      this.caseSearchReq.order = prop;
      if (order === 'descending') {
        this.caseSearchReq.sort = 'desc';
      }
      if (order === 'ascending') {
        this.caseSearchReq.sort = 'asc';
      }
      this.noticeSearch();
    },
    add() {
      this.$ajax({
        method: 'POST',
        url: '/notice/add',
        prompt: true,
        data: this.noticeBodyReq
      }).then(() => {
        this.noticeVisible = false;
        this.noticeSearch();
      });
    },
    editShow(row) {
      this.cleanReq();
      this.copyReq(row);
      this.addNotice = false;
      this.noticeVisible = true;
    },
    update() {
      this.$ajax({
        method: 'POST',
        url: `/notice/update/${this.noticeBodyReq.id}`,
        prompt: true,
        data: this.noticeBodyReq
      }).then(() => {
        this.noticeVisible = false;
        this.noticeSearch();
      });
    },
    updateStatus(id, status) {
      this.$ajax({
        method: 'POST',
        url: `/notice/update/${id}/${status}`,
        prompt: true
      }).then(() => {
        this.noticeSearch();
      });
    },
    deleteNotice(id) {
      this.$confirm('此操作将永久删除该通知, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/notice/delete/${id}`
        }).then(() => {
          this.noticeSearch();
        });
      });
    },
    cleanReq() {
      this.noticeBodyReq.title = null;
      this.noticeBodyReq.mailTo = null;
      this.noticeBodyReq.contentType = [];
      this.noticeBodyReq.sendType = 1;
      this.noticeBodyReq.sendTime = '08:00:00';
      this.noticeBodyReq.sendCondition = ['1', '2'];
      this.noticeBodyReq.status = 1;
      this.noticeBodyReq.id = null;
      this.sendTypeRelation = '前日';
    },
    copyReq(row) {
      this.noticeBodyReq.title = row.title;
      this.noticeBodyReq.mailTo = row.mailTo;
      this.noticeBodyReq.contentType = row.contentType;
      this.noticeBodyReq.sendType = row.sendType;
      this.noticeBodyReq.sendTime = row.sendTime;
      this.noticeBodyReq.sendCondition = row.sendCondition;
      this.noticeBodyReq.status = row.status;
      this.noticeBodyReq.id = row.id;

      this.sendTypeChange(this.noticeBodyReq.sendType);
    },
    sendTypeChange(sendType) {
      if (sendType === 1) {
        this.sendTypeRelation = '前日';
      } else if (sendType === 2) {
        this.sendTypeRelation = '上周';
      } else if (sendType === 3) {
        this.sendTypeRelation = '上月';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/company/notice.vue